<div class="ai-writing-toolbar" [class.ai-writing-toolbar--compact]="density === 'compact'">
  <ng-container *ngIf="hasText">
    <button type="button" class="ai-tool-btn" [class.ai-tool-btn--icon]="density === 'compact'"
      [disabled]="proofreading" tooltip="{{ (density === 'compact' ? 'Proofread' : '') | translate }}"
      placement="top" (mousedown)="$event.preventDefault()" (click)="proofread.emit()">
      <span class="ai-btn-icon-wrap">
        <svg class="ai-btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" [class.ai-icon-hidden]="proofreading">
          <defs>
            <linearGradient id="aiGradProof{{instanceId}}" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#FE4649"/>
              <stop offset="0.4" stop-color="#CD5CC2"/>
              <stop offset="0.7" stop-color="#8B68EF"/>
              <stop offset="1" stop-color="#3E96FE"/>
            </linearGradient>
          </defs>
          <circle cx="8.5" cy="8.5" r="5.5" [attr.stroke]="'url(#aiGradProof' + instanceId + ')'" stroke-width="1.6"/>
          <path d="M16.5 16.5l-4-4" [attr.stroke]="'url(#aiGradProof' + instanceId + ')'" stroke-width="1.6" stroke-linecap="round"/>
          <path d="M6 8.6l1.7 1.7 3.3-3.9" [attr.stroke]="'url(#aiGradProof' + instanceId + ')'" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="ai-btn-spinner" [class.ai-spinner-visible]="proofreading"><span class="ai-btn-spinner-ring"></span></span>
      </span>
      <span class="ai-btn-label" *ngIf="density !== 'compact'">{{ 'Proofread' | translate }}</span>
    </button>
    <span class="ai-tool-divider" *ngIf="density !== 'compact'"></span>
    <button type="button" class="ai-tool-btn" [class.ai-tool-btn--icon]="density === 'compact'"
      [disabled]="rewriting" tooltip="{{ (density === 'compact' ? 'Rewrite' : '') | translate }}"
      placement="top" (mousedown)="$event.preventDefault()" (click)="rewrite.emit()">
      <span class="ai-btn-icon-wrap">
        <svg class="ai-btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" [class.ai-icon-hidden]="rewriting">
          <defs>
            <linearGradient id="aiGradRewrite{{instanceId}}" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#FE4649"/>
              <stop offset="0.4" stop-color="#CD5CC2"/>
              <stop offset="0.7" stop-color="#8B68EF"/>
              <stop offset="1" stop-color="#3E96FE"/>
            </linearGradient>
          </defs>
          <path d="M11.6 4.3a1.8 1.8 0 012.6 2.6L6.9 14.3l-3.4.8.8-3.4 7.3-7.4z" [attr.stroke]="'url(#aiGradRewrite' + instanceId + ')'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16.2 12.6l.6 1.4 1.4.6-1.4.6-.6 1.4-.6-1.4-1.4-.6 1.4-.6z" [attr.fill]="'url(#aiGradRewrite' + instanceId + ')'"/>
        </svg>
        <span class="ai-btn-spinner" [class.ai-spinner-visible]="rewriting"><span class="ai-btn-spinner-ring"></span></span>
      </span>
      <span class="ai-btn-label" *ngIf="density !== 'compact'">{{ 'Rewrite' | translate }}</span>
    </button>
    <span class="ai-tool-divider" *ngIf="density !== 'compact'"></span>
    <button type="button" class="ai-tool-btn" [class.ai-tool-btn--icon]="density === 'compact'"
      [class.ai-tool-btn--on]="adjustOpen"
      [disabled]="adjusting" tooltip="{{ (density === 'compact' ? 'Adjust' : '') | translate }}"
      placement="top" (mousedown)="$event.preventDefault()" (click)="adjust.emit()"
      [attr.aria-expanded]="adjustOpen">
      <span class="ai-btn-icon-wrap">
        <svg class="ai-btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" [class.ai-icon-hidden]="adjusting">
          <defs>
            <linearGradient id="aiGradAdjust{{instanceId}}" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#FE4649"/>
              <stop offset="0.4" stop-color="#CD5CC2"/>
              <stop offset="0.7" stop-color="#8B68EF"/>
              <stop offset="1" stop-color="#3E96FE"/>
            </linearGradient>
          </defs>
          <path d="M3 6h8M15 6h2M3 14h2M9 14h8" [attr.stroke]="'url(#aiGradAdjust' + instanceId + ')'" stroke-width="1.6" stroke-linecap="round"/>
          <circle cx="13" cy="6" r="2.1" [attr.stroke]="'url(#aiGradAdjust' + instanceId + ')'" stroke-width="1.6"/>
          <circle cx="7" cy="14" r="2.1" [attr.stroke]="'url(#aiGradAdjust' + instanceId + ')'" stroke-width="1.6"/>
        </svg>
        <span class="ai-btn-spinner" [class.ai-spinner-visible]="adjusting"><span class="ai-btn-spinner-ring"></span></span>
      </span>
      <span class="ai-btn-label" *ngIf="density !== 'compact'">{{ 'Adjust' | translate }}</span>
    </button>
  </ng-container>

  <ng-container *ngIf="hasHistory">
    <span class="ai-tool-divider" *ngIf="hasText && density !== 'compact'"></span>

    <!-- Full density: separate Undo/Redo/History icon buttons, same as roadmap. -->
    <ng-container *ngIf="density !== 'compact'">
      <button type="button" class="ai-tool-btn ai-tool-btn--icon" [disabled]="!canUndo"
        tooltip="{{ 'Undo AI change' | translate }}" placement="top"
        (mousedown)="$event.preventDefault()" (click)="undo.emit()" [attr.aria-label]="'Undo AI change' | translate">
        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5 5.5 5.5 0 0 1-5.5 5.5H11"/></svg>
      </button>
      <button type="button" class="ai-tool-btn ai-tool-btn--icon" [disabled]="!canRedo"
        tooltip="{{ 'Redo AI change' | translate }}" placement="top"
        (mousedown)="$event.preventDefault()" (click)="redo.emit()" [attr.aria-label]="'Redo AI change' | translate">
        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5 5.5 5.5 0 0 0 9.5 20H13"/></svg>
      </button>
      <span class="ai-tool-divider"></span>
      <button type="button" class="ai-tool-btn ai-tool-btn--icon" tooltip="{{ 'Version history' | translate }}" placement="top"
        (mousedown)="$event.preventDefault()" (click)="history.emit()" [attr.aria-label]="'Version history' | translate">
        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>
      </button>
    </ng-container>

    <!-- Compact density: one overflow button opening a small menu with the same three actions. -->
    <div class="ai-tool-overflow" *ngIf="density === 'compact'">
      <button type="button" class="ai-tool-btn ai-tool-btn--icon" tooltip="{{ 'More' | translate }}" placement="top"
        (mousedown)="$event.preventDefault()" (click)="toggleOverflow()" [attr.aria-label]="'More' | translate">
        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/></svg>
      </button>
      <div class="ai-tool-overflow-menu" *ngIf="overflowOpen">
        <button type="button" class="ai-tool-overflow-item" [disabled]="!canUndo"
          (mousedown)="$event.preventDefault()" (click)="undo.emit(); closeOverflow()">
          <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5 5.5 5.5 0 0 1-5.5 5.5H11"/></svg>
          <span>{{ 'Undo AI change' | translate }}</span>
        </button>
        <button type="button" class="ai-tool-overflow-item" [disabled]="!canRedo"
          (mousedown)="$event.preventDefault()" (click)="redo.emit(); closeOverflow()">
          <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5 5.5 5.5 0 0 0 9.5 20H13"/></svg>
          <span>{{ 'Redo AI change' | translate }}</span>
        </button>
        <button type="button" class="ai-tool-overflow-item"
          (mousedown)="$event.preventDefault()" (click)="history.emit(); closeOverflow()">
          <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>
          <span>{{ 'Version history' | translate }}</span>
        </button>
      </div>
    </div>
  </ng-container>
</div>
